/**
 * TODO: TECHNICAL DEBT — what a `403` means to a client is a decision about person-api's contract,
 * not about what this page renders. Tracked in #2094; parked rather than resolved on the owner's
 * ruling in the PR #2085 review. The rebuild that inherits it is #2095.
 *
 * Whether a failed API call was a refusal, as opposed to anything else that can go wrong.
 *
 * **Reads `response.status` and nothing else, deliberately.** It looks like the check that ought to
 * be paired with an `axios.isAxiosError` guard, and it is not: `interceptorWithToken` rethrows a
 * 4xx as the original `AxiosError`, where `response.status` is present, but replaces every 5xx with
 * a plain `{ code, message, originalResponse }`, which has no `response` key at all. A server error
 * therefore fails this test on its own shape. Adding `axios` to this package to assert what the
 * shape already settles would be a dependency bought for nothing (and `turbo-ignore` walks declared
 * dependencies, so the ones this package carries are load-bearing beyond the import).
 *
 * A network failure and a cancelled request also have no `response`, and land the same way.
 *
 * **Its own module rather than a shared export from either caller.** It began inside
 * `useFaceCheckTasks`; exporting it from there made `useRequestPermission` import that hook's whole
 * graph — including `@verifime/components` — for a three-line predicate, which its unit tests
 * refused to load. The failure was the design feedback: this is about the shape the API client
 * leaves an error in, which is neither hook's subject.
 */
export function isRefusal(error: unknown): boolean {
  return (error as { response?: { status?: number } })?.response?.status === 403;
}
